'use strict';

export default class AdminController {
  users;

  constructor(UserSvc) {
    // Use the User $resource to fetch all users
    this.users = UserSvc.query();
  }

  delete(user) {
    user.$remove();
    this.users.splice(this.users.indexOf(user), 1);
  }
}
